import React from "react";
import AuthPageLayout from "../../../layouts/VerticalLayouts/AuthPageLayout";
import { Button } from "reactstrap";
import astronautImg from "../../../assets/images/astronaut.png";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const ForbiddenPage = () => {
  const { t } = useTranslation();
  return (
    <AuthPageLayout>
      <div className="error-page__wrapper">
        <div className="error-page__image-wrapper">
          <img src={astronautImg} alt="" width={312} height={318} />
        </div>
        <div className="error-page__content">
          <h1 className="error-page__404">403</h1>
          <p className="text-muted mt-0">{t("errorPages.forbidden.message")}</p>
          <Link to="/login">
            <Button outline color="primary" className="mt-2">
              {t("errorPages.backToLogin")}
            </Button>
          </Link>
        </div>
      </div>
    </AuthPageLayout>
  );
};

export default ForbiddenPage;
